



















































































































































import CollapseTransition from '@/components/collapseTransition/collapseTransition'; // 导入过渡函数
import PagingUnit from '@/components/paging/paging.vue'; // 导入分页组件
import { Component, Vue, PropSync, Watch } from 'vue-property-decorator';
import { TableStripe } from '@/mixins/tableStripe';
import { institutionServer, performanceServer, userServe } from '@/api/installServer';
import { arrayToTree } from '@/util/arrayToTree';
import ViewInventoryDetails from '@/views/inventoryManagement/unit/viewInventoryDetails.vue';
import BatchDialogData from '@/views/inventoryManagement/unit/batchDialogData.vue';

import ViewDialog from '@/views/responsibility/unit/viewDialog.vue';

@Component({
  components: {
    ViewInventoryDetails,
    CollapseTransition,
    PagingUnit,
    ViewDialog,
    BatchDialogData,
  },
  mixins: [TableStripe],
})
export default class PerformanceManagement extends Vue {
  // 查询分页表单
  queryDataForm: object = {
    pageNo: 1,
    pageSize: 10,
  };
  total = 0; // 总共多少条数据
  pageIndex = 1; // 总共多少条数据
  private editData: any = {}; //选中的单挑编辑项
  private NewType: any = ''; //选中的单挑编辑项
  obj: object = {}; // 搜索需要的对象
  // 表单数据对象
  formData: any = {
    executeDepartmentIdAndSub: '',
    executeStaffId: '',
    search: '',
    frequency: '',
    frequencyUnit: '',
    createTask: null,
  };
  // table 数据对象
  tableData: any = [];

  // 执行部门
  subSpaceByAuthOptions: any = [];
  spaceStaffByAuthOptions: any = [];

  multipleSelection: any = [];
  // 履职清单批量记录id
  dutyRuleListBatchId: any = '';
  dutyRuleListBatchName: any = '';

  viewTaskInfo(data: any) {
    const viewDialog: any = 'viewDialog';
    const viewDialogRef: any = this.$refs[viewDialog];
    viewDialogRef.showDialog(data);
  }

  /**
   * @desc Vue 创建数据钩子函数
   * @param1 暂无
   * @returns 暂无
   */
  created() {
    if (this.$route.query.dutyRuleListBatchId) {
      this.dutyRuleListBatchId = this.$route.query.dutyRuleListBatchId;
      this.dutyRuleListBatchName = this.$route.query.dutyRuleListBatchName;
    }
    this.getSubSpaceByAuth();
    // 获取分页数据
    this.getPageData();
  }
  /**
   * @desc 获取部门所有数据
   * @param1 暂无
   * @returns 暂无
   */
  getSubSpaceByAuth() {
    // 发起接口请求，获取分页数据
    institutionServer
      .getAllData({ topDeptType: '3' })
      .then((res: any) => {
        this.subSpaceByAuthOptions = arrayToTree(res.data);
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }
  // 部门筛选： 岗位 / 人员
  getChangePost(e: any) {
    this.formData.executeStaffId = '';
    if (e) {
      this.getSpaceStaffByAuth(e);
    } else {
      this.spaceStaffByAuthOptions = [];
    }
  }
  /**
   * @desc 获取人员数据
   * @param1 暂无
   * @returns 暂无
   */
  getSpaceStaffByAuth(id: any) {
    // 发起接口请求，获取分页数据
    userServe
      .getPageDataAll({ deptId: id })
      .then((res: any) => {
        this.spaceStaffByAuthOptions = res.data;
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  // 创建开始点击事件
  createExam(type: any, data?: any) {
    switch (type) {
      case 'add':
        this.pageIndex = 2;
        this.NewType = type;
        break;
      case 'edit':
        this.pageIndex = 3;
        this.NewType = type;
        this.editData = data;
        break;
    }
  }

  // 查看
  viewManagement(data: any) {
    this.pageIndex = 4;
    this.editData = data;
  }

  /**
   * @desc 获取所有数据
   * @param1 暂无
   * @returns 暂无
   */
  getPageData() {
    this.pageIndex = 1;
    // 发起接口请求，获取分页数据
    performanceServer
      .getDutyRuleList({
        current: (this.queryDataForm as any).pageNo,
        size: (this.queryDataForm as any).pageSize,
        executeDepartmentIdAndSub: this.formData.executeDepartmentIdAndSub ? this.formData.executeDepartmentIdAndSub : null,
        search: this.formData.search ? this.formData.search : null,
        executeTopDeptType: '3',
        executeStaffId: this.formData.executeStaffId ? this.formData.executeStaffId : null,
        frequencyUnit: this.formData.frequencyUnit ? '年' : null,
        frequency: this.formData.frequencyUnit === '年' ? '1' : this.formData.frequencyUnit === '季' ? '4' : this.formData.frequencyUnit === '月' ? '12' : this.formData.frequencyUnit === '周' ? '52' : null,
        createTask: this.formData.createTask,
        dutyRuleListBatchId: this.dutyRuleListBatchId,
      })
      .then((res: any) => {
        this.tableData = res.data.records;
        this.total = res.data.total;
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  /**
         @description: 数组去重
         @author: cxf
         @update: cxf 2021/7/26 16:20
         **/
  public unique(arr: any) {
    for (let i = 0; i < arr.length; i++) {
      for (let j = i + 1; j < arr.length; j++) {
        if (arr[i].id === arr[j].id || arr[i].id === undefined || arr[j].id === undefined) {
          // 第一个等同于第二个，splice方法删除第二个
          arr.splice(j, 1);
          j--;
        }
      }
    }
    return arr;
  }

  /**
   * @desc 点击分页按钮触发，改变内容
   * @param1 暂无
   * @returns 暂无
   */
  getListData() {
    // 调用获取分页数据
    this.getPageData();
  }

  /**
   * @desc 点击查询按钮触发，查询符合条件的内容.
   * @param1 暂无
   * @returns 暂无
   */
  search() {
    (this.queryDataForm as any).pageNo = 1;
    (this.queryDataForm as any).pageSize = 10;
    this.getPageData();
  }

  /**
   * @desc 点击查询按钮触发，查询符合条件的内容.
   * @param1 暂无
   * @returns 暂无
   */
  resetFormData() {
    (this.queryDataForm as any).pageNo = 1;
    (this.queryDataForm as any).pageSize = 10;
    this.formData = {
      executeDepartmentId: '',
      executePostId: '',
      executeStaffId: '',
      search: '',
      createTask: null,
    };
    this.dutyRuleListBatchId = '';
    this.getPageData();
  }
  /**
   * 表格选中的变化
   */
  handleSelectionChange(val: any) {
    this.multipleSelection = val;
  }
  batchCreateTask() {
    if (!this.multipleSelection.length) {
      this.$message.warning('请选择需要生成任务的数据');
      return;
    } else {
      const containCreateData: any = this.multipleSelection.some((item: any) => item.createTask);
      if (containCreateData) {
        this.$message.warning('所选数据中包含已创建的任务，请选择未创建的任务');
        return;
      } else {
        const selectedDataIds: any = this.multipleSelection.map((item: any) => {
          return item.id;
        });
        const BatchDialogDataDataComponent: any = this.$refs['BatchDialogData'];
        BatchDialogDataDataComponent.showDialog(selectedDataIds);
      }
    }
  }

  /**
   * 返回履职批量页面
   */
  backDutyListBatch() {
    this.$router.go(-1);
  }
}
